import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { throwIfAlreadyLoaded } from './module-import.guard';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [],
    declarations: [],
})
export class GuardsModule {
    constructor(@Optional() @SkipSelf() parentModule: GuardsModule) {
        throwIfAlreadyLoaded(parentModule, 'GuardsModule');
    }
    static forRoot(): ModuleWithProviders<GuardsModule> {
        return {
            ngModule: GuardsModule,
            providers: [],
        };
    }
}